import * as R from 'ramda';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
import {
  ITEM_VOLUME_OPTIONS,
  getFreightClassOptions,
  ITEM_DIMENSIONS_OPTIONS,
  ITEM_TEMPERATURE_OPTIONS,
  ITEM_ODOMETER_UOM_OPTIONS,
  ITEM_TEMPERATURE_TYPE_OPTIONS,
  DEFAULT_ITEM_WEIGHT_UOM_OPTIONS,
  DEFAULT_QUANTITY_RATE_UNIT_OPTIONS,
} from '../../../../helpers/options';
//////////////////////////////////////////////////

const getDisplayedValue = (value, options) => R.compose(
  R.propOr('', GC.FIELD_LABEL),
  R.find(R.propEq(value, GC.FIELD_VALUE)),
)(options);

export const itemSettings = {
  [GC.FIELD_ITEM_ID]: {
    name: 'titles:item-id',
  },
  [GC.FIELD_ACTIVE]: {
    fieldType: 'boolean',
    filterType: 'boolean',
    name: 'titles:active',
  },
  [GC.FIELD_BRANCH_DOT_BRANCH_NAME]: {
    name: 'titles:branch',
  },
  [GC.FIELD_ITEM_FREIGHT_CLASS]: {
    name: 'titles:freight-class',
    filterType: 'selectMultiple',
    value: GC.FIELD_ITEM_FREIGHT_CLASS,
    options: R.tail(getFreightClassOptions()),
    customComponent: ({ fieldData }) => getDisplayedValue(fieldData, getFreightClassOptions()),
  },
  [GC.FIELD_ITEM_WEIGHT]: {
    filterType: 'number',
    name: 'titles:weight',
  },
  [GC.FIELD_ITEM_WEIGHT_TYPE]: {
    name: 'titles:weight-type',
    filterType: 'selectMultiple',
    options: R.tail(DEFAULT_ITEM_WEIGHT_UOM_OPTIONS),
    customComponent: ({ fieldData }) => getDisplayedValue(fieldData, DEFAULT_ITEM_WEIGHT_UOM_OPTIONS),
  },
  [GC.FIELD_ITEM_TEMPERATURE_TYPE]: {
    filterType: 'selectMultiple',
    name: 'titles:temperature-type',
    options: R.tail(ITEM_TEMPERATURE_TYPE_OPTIONS),
  },
  [GC.FIELD_ITEM_TEMPERATURE_SENSOR]: {
    name: 'titles:temperature-sensor',
  },
  [GC.FIELD_ITEM_QUANTITY]: {
    filterType: 'number',
    name: 'titles:quantity',
  },
  [GC.FIELD_PACKAGE_TYPE]: {
    name: 'titles:package-type',
    filterType: 'selectMultiple',
    options: R.tail(DEFAULT_QUANTITY_RATE_UNIT_OPTIONS),
    customComponent: ({ fieldData }) => getDisplayedValue(fieldData, DEFAULT_QUANTITY_RATE_UNIT_OPTIONS),
  },
  [GC.FIELD_PALLET_SPACES]: {
    filterType: 'number',
    name: 'titles:pallet-spaces',
  },
  [GC.FIELD_BILLABLE_WEIGHT]: {
    filterType: 'number',
    name: 'titles:billable-weight',
  },
  [GC.FIELD_CASE_COUNT]: {
    filterType: 'number',
    name: 'titles:case-count',
  },
  [GC.FIELD_ITEM_DIMENSIONS_LENGTH]: {
    filterType: 'number',
    name: 'titles:dimensions-length',
  },
  [GC.FIELD_ITEM_DIMENSIONS_WIDTH]: {
    filterType: 'number',
    name: 'titles:dimensions-width',
  },
  [GC.FIELD_ITEM_DIMENSIONS_HEIGHT]: {
    filterType: 'number',
    name: 'titles:dimensions-height',
  },
  [GC.FIELD_ITEM_DIMENSIONS_UOM]: {
    fieldType: 'uomLocale',
    filterType: 'selectMultiple',
    name: 'titles:dimensions-uom',
    options: R.tail(ITEM_DIMENSIONS_OPTIONS),
    customComponent: ({ fieldData }) => getDisplayedValue(fieldData, ITEM_DIMENSIONS_OPTIONS),
  },
  [GC.FIELD_DESCRIPTION]: {
    name: 'titles:description',
  },
  [GC.FIELD_ITEM_COMMODITY]: {
    name: 'titles:commodity',
  },
  [GC.FIELD_ITEM_MONETARY_VALUE]: {
    filterType: 'number',
    name: 'titles:monetary-value',
  },
  [GC.FIELD_ITEM_MONETARY_VALUE_CURRENCY]: {
    filterType: 'selectMultiple',
    options: GC.CURRENCY_OPTIONS_2,
    name: 'titles:monetary-currency',
  },
  [GC.FIELD_PO_NUMBER]: {
    name: 'titles:po-number',
  },
  [GC.FIELD_ITEM_VOLUME]: {
    filterType: 'number',
    name: 'titles:volume',
  },
  [GC.FIELD_ITEM_VOLUME_UOM]: {
    name: 'titles:volume-uom',
    filterType: 'selectMultiple',
    options: R.tail(ITEM_VOLUME_OPTIONS),
    customComponent: ({ fieldData }) => getDisplayedValue(fieldData, ITEM_VOLUME_OPTIONS),
  },
  [GC.FIELD_ITEM_DECLARED_VALUE]: {
    filterType: 'number',
    name: 'titles:declared-value',
  },
  [GC.FIELD_ITEM_DECLARED_CURRENCY]: {
    name: 'titles:currency',
    filterType: 'selectMultiple',
    options: GC.CURRENCY_OPTIONS_2,
  },
  [GC.FIELD_ITEM_STACKABILITY]: {
    fieldType: 'boolean',
    filterType: 'boolean',
    name: 'titles:stackability',
  },
  [GC.FIELD_ITEM_STACKABILITY_CONDITION]: {
    name: 'titles:stackability-condition',
  },
  [GC.FIELD_ITEM_CUSTOMER_PART_NUMBER]: {
    name: 'titles:customer-part-num',
  },
  [GC.FIELD_ITEM_TEMPERATURE_LOW]: {
    filterType: 'number',
    name: 'titles:temperature-minimum',
  },
  [GC.FIELD_ITEM_TEMPERATURE_HIGH]: {
    filterType: 'number',
    name: 'titles:temperature-maximum',
  },
  [GC.FIELD_ITEM_TEMPERATURE_UOM]: {
    filterType: 'selectMultiple',
    name: 'titles:temperature-uom',
    options: R.tail(ITEM_TEMPERATURE_OPTIONS),
  },
  [GC.FIELD_ITEM_N_M_F_C]: {
    name: 'titles:nmfc',
  },
  [GC.FIELD_ITEM_S_T_C_C]: {
    name: 'titles:stcc',
  },
  [GC.FIELD_ITEM_HARMONIZED_TARIFF]: {
    name: 'titles:harmonized-tariff',
  },
  [GC.FIELD_ITEM_COMMODITY_TYPE]: {
    name: 'titles:domestic-foreign-military',
  },
  [GC.FIELD_ITEM_E_C_C_N]: {
    name: 'titles:eccn',
  },
  [GC.FIELD_ITEM_HAZARDOUS]: {
    fieldType: 'boolean',
    filterType: 'boolean',
    name: 'titles:hazardous',
  },
  [GC.FIELD_TAPA]: {
    name: 'titles:tapa',
    fieldType: 'boolean',
    filterType: 'boolean',
  },
  [GC.FIELD_HIGH_SECURITY]: {
    fieldType: 'boolean',
    filterType: 'boolean',
    name: 'titles:high-sequrity',
  },
  [GC.FIELD_PHARMA]: {
    fieldType: 'boolean',
    filterType: 'boolean',
    name: 'titles:pharma',
  },
  [GC.FIELD_ITEM_HAZMAT_UN_OR_NA_NUMBER]: {
    name: 'titles:hazmat-un-or-na-number',
  },
  [GC.FIELD_ITEM_HAZMAT_PACKAGE_GROUP]: {
    name: 'titles:hazmat-package-group',
  },
  [GC.FIELD_ITEM_HAZMAT_CLASS]: {
    name: 'titles:hazmat-class',
  },
  [GC.FIELD_ITEM_HAZMAT_SHIPPING_NAME]: {
    name: 'titles:hazmat-shipping-name',
  },
  [GC.FIELD_ITEM_HAZMAT_CONTACT_NAME]: {
    name: 'titles:hazmat-contact-name',
  },
  [GC.FIELD_ITEM_HAZMAT_CONTACT_PHONE]: {
    name: 'titles:hazmat-contact-phone',
  },
  [GC.FIELD_ITEM_HAZMAT_EMS_NUMBER]: {
    name: 'titles:hazmat-ems-number',
  },
  [GC.FIELD_ITEM_HAZMAT_PLACARDS]: {
    fieldType: 'boolean',
    filterType: 'boolean',
    name: 'titles:hazmat-placards',
  },
  [GC.FIELD_ITEM_HAZMAT_PLACARDS_DETAILS]: {
    name: 'titles:hazmat-placard-details',
  },
  [GC.FIELD_ITEM_HAZMAT_FLASHPOINT]: {
    filterType: 'number',
    name: 'titles:hazmat-flashpoint',
  },
  [GC.FIELD_ITEM_HAZMAT_FLASHPOINT_UOM]: {
    filterType: 'selectMultiple',
    name: 'titles:hazmat-flashpoint-uom',
    options: R.tail(ITEM_TEMPERATURE_OPTIONS),
  },
  [GC.FIELD_ITEM_HAZMAT_COMMENT]: {
    name: 'titles:hazmat-comments',
  },
  [GC.FIELD_MANUFACTURER]: {
    name: 'titles:manufacturer',
  },
  [GC.FIELD_OPERATIONAL]: {
    fieldType: 'boolean',
    filterType: 'boolean',
    name: 'titles:operational',
  },
  [GC.FIELD_YEAR]: {
    name: 'titles:year',
    filterType: 'number',
  },
  [GC.FIELD_MAKE]: {
    name: 'titles:make',
  },
  [GC.FIELD_MODEL]: {
    name: 'titles:model',
  },
  [GC.FIELD_SUB_MODEL]: {
    name: 'titles:sub-model',
  },
  [GC.FIELD_WHEELBASE]: {
    filterType: 'number',
    name: 'titles:wheelbase',
  },
  [GC.FIELD_WHEELBASE_UOM]: {
    name: 'titles:wheelbase-uom',
    filterType: 'selectMultiple',
    options: R.tail(ITEM_DIMENSIONS_OPTIONS),
    customComponent: ({ data }) => R.compose(
      R.pathOr('', [GC.FIELD_LABEL]),
      R.find(R.propEq(G.getPropFromObject(GC.FIELD_WHEELBASE_UOM, data), GC.FIELD_VALUE)),
    )(ITEM_DIMENSIONS_OPTIONS),
  },
  [GC.FIELD_BAY]: {
    name: 'titles:bay',
  },
  [GC.FIELD_ODOMETER]: {
    filterType: 'number',
    name: 'titles:odometer',
  },
  [GC.FIELD_ODOMETER_UOM]: {
    name: 'titles:odometer-uom',
    filterType: 'selectMultiple',
    options: R.tail(ITEM_ODOMETER_UOM_OPTIONS),
    customComponent: ({ data }) => R.compose(
      R.pathOr('', [GC.FIELD_LABEL]),
      R.find(R.propEq(G.getPropFromObject(GC.FIELD_ODOMETER_UOM, data), GC.FIELD_VALUE)),
    )(ITEM_ODOMETER_UOM_OPTIONS),
  },
  [GC.FIELD_COLOR]: {
    name: 'titles:color',
  },
  [GC.FIELD_LICENSE_PLATE]: {
    name: 'titles:license-plate',
  },
  [GC.FIELD_VIN]: {
    name: 'titles:vin',
  },
  [GC.FIELD_ORIGIN_STATE]: {
    name: 'titles:origin-state',
  },
  [GC.FIELD_ORIGIN_COUNTRY]: {
    name: 'titles:origin-country',
  },
  [GC.FIELD_ORIGIN_OF_GOODS]: {
    name: 'titles:origin-of-goods',
  },
};
